import React, { Fragment, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_RESP_STATUS } from "../../Constant/constant";
import { getAccountList, deleteAccount } from "../Apis/apis";
import AddDailog from "../Record/AddDailog";
import AllStateContext from "../../context/allstateContext";
import AccountDialog from "../Record/AccountDialog";
import DateDialog from "../../Common/DateDialog";
import TimeDialog from "../../Common/TimeDialog";
import { useQuery } from "react-query";
import AddNewAccountDialog from "../../Common/AddNewAccountDialog";
import DeletedConfirmationDialog from "../../Common/DeletedConfirmationDialog";

//dialog

const Accounts = () => {
  const history = useNavigate();
  const {
    openAccount,
    openDateDialog,
    openTimeDialog,
    setAddNewAccountDialog,
    setSelectedAccountItem,
    openDeleteConfirmationDialog,
    setOpenDeleteConfirmationDialog,
    addNewAccountDialog,
    setSearchDetail,
  } = useContext(AllStateContext);
  const { data, error, isLoading, refetch } = useQuery(
    ["accountsListApiCall"],
    async () => {
      const response = await getAccountList();
      return response.data;
    }
  );
  if (error) {
    if (error.response.status == API_RESP_STATUS.unauthorized) {
      localStorage.removeItem("token");
      history("/login");
    }
  }

  const [deleteItemId, setDeleteItemId] = useState(null);
  const handelEdit = async (item, event) => {
    if (event === "edit") {
      setSelectedAccountItem(item);
      setAddNewAccountDialog(true);
    } else {
      setDeleteItemId(item.accountId);
      setOpenDeleteConfirmationDialog(true);
    }
  };
  const handelDeleted = async () => {
    if (!deleteItemId) return;
    try {
      await deleteAccount(deleteItemId);
      refetch();
    } catch (err) {
      console.error("Delete account failed:", err);
    }
    setDeleteItemId(null);
  };

  return (
    <div className="container" style={{ paddingBottom: "40px", marginTop: "80px" }}>
      <div>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {/* Balance Summary Header Cards */}
            <div className="row g-3 mb-4">
              <div className="col-12 col-md-4">
                <div 
                  style={{
                    background: "rgba(239, 68, 68, 0.03)",
                    border: "1px solid rgba(239, 68, 68, 0.1)",
                    borderLeft: "4px solid var(--danger)",
                    borderRadius: "12px",
                    padding: "16px"
                  }}
                >
                  <div style={{ fontSize: "0.85rem", fontWeight: "600", color: "var(--text-secondary)", letterSpacing: "0.05em", textTransform: "uppercase" }}>
                    Expense So Far
                  </div>
                  <div style={{ fontSize: "1.6rem", fontWeight: "800", color: "var(--danger)", marginTop: "4px" }}>
                    {`₹${(data?.payload?.totalInEx || 0).toLocaleString("en-IN")}`}
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div 
                  style={{
                    background: "rgba(16, 185, 129, 0.03)",
                    border: "1px solid rgba(16, 185, 129, 0.1)",
                    borderLeft: "4px solid var(--success)",
                    borderRadius: "12px",
                    padding: "16px"
                  }}
                >
                  <div style={{ fontSize: "0.85rem", fontWeight: "600", color: "var(--text-secondary)", letterSpacing: "0.05em", textTransform: "uppercase" }}>
                    Income So Far
                  </div>
                  <div style={{ fontSize: "1.6rem", fontWeight: "800", color: "var(--success)", marginTop: "4px" }}>
                    {`₹${(data?.payload?.totalInBal || 0).toLocaleString("en-IN")}`}
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4">
                {(() => {
                  const netBalance = (data?.payload?.totalInBal - data?.payload?.totalInEx) || 0;
                  const isNegative = netBalance < 0;
                  return (
                    <div 
                      style={{
                        background: isNegative ? "rgba(239, 68, 68, 0.03)" : "rgba(99, 102, 241, 0.03)",
                        border: "1px solid " + (isNegative ? "rgba(239, 68, 68, 0.1)" : "rgba(99, 102, 241, 0.1)"),
                        borderLeft: "4px solid " + (isNegative ? "var(--danger)" : "var(--primary)"),
                        borderRadius: "12px",
                        padding: "16px"
                      }}
                    >
                      <div style={{ fontSize: "0.85rem", fontWeight: "600", color: "var(--text-secondary)", letterSpacing: "0.05em", textTransform: "uppercase" }}>
                        Total Balance
                      </div>
                      <div style={{ fontSize: "1.6rem", fontWeight: "800", color: isNegative ? "var(--danger)" : "var(--text-primary)", marginTop: "4px" }}>
                        {isNegative ? `-₹${Math.abs(netBalance).toLocaleString("en-IN")}` : `₹${netBalance.toLocaleString("en-IN")}`}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>

            <AddDailog fetchData={refetch} />
            {openAccount && <AccountDialog />}
            {openDateDialog && <DateDialog />}
            {openTimeDialog && <TimeDialog />}
            {addNewAccountDialog && <AddNewAccountDialog refetch={refetch} />}
            {openDeleteConfirmationDialog && (
              <DeletedConfirmationDialog isDeleted={handelDeleted} />
            )}

            <div className="glass-card">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h5 style={{ fontWeight: "700", margin: "0", letterSpacing: "0.02em" }}>
                  Your Accounts
                </h5>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setAddNewAccountDialog(true)}
                  style={{ padding: "8px 18px", fontSize: "0.88rem", fontWeight: "600" }}
                >
                  <img
                    style={{ width: "16px", height: "16px", filter: "invert(1)" }}
                    src={require("../../Common/Icon/plus.png")}
                    alt="plus"
                  />
                  Add Account
                </button>
              </div>

              <div className="list-group" style={{ margin: "0", border: "1px solid var(--border-color)" }}>
                {data && data?.payload?.data
                  ?.filter((item) => item.accountId)
                  ?.map((item) => (
                    <div 
                      className="list-group-item d-flex align-items-center justify-content-between" 
                      key={item?.accountId}
                      style={{
                        padding: "16px 20px !important",
                        borderBottom: "1px solid var(--border-color)",
                        cursor: "pointer"
                      }}
                    >
                      <div 
                        className="d-flex align-items-center gap-3"
                        style={{ flex: 1 }}
                        onClick={() => {
                          setSearchDetail({ balance: "", name: item.name });
                          history("/home");
                        }}
                      >
                        <div 
                          style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "10px",
                            background: "var(--bg-surface-hover)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid var(--border-color)"
                          }}
                        >
                          <img
                            style={{ height: "26px", width: "26px" }}
                            src={item?.iconDetail?.icon}
                            alt={item?.name}
                          />
                        </div>
                        <div>
                          <div style={{ fontWeight: "700", fontSize: "0.95rem" }}>
                            {item.name}
                          </div>
                          <div
                            style={{
                              fontSize: "0.85rem",
                              fontWeight: "600",
                              color: item?.balance < 0 ? "var(--danger)" : "var(--success)",
                              marginTop: "2px"
                            }}
                          >
                            {item?.balance < 0
                              ? `Balance: -₹${Math.abs(item.balance).toLocaleString("en-IN")}`
                              : `Balance: ₹${item.balance.toLocaleString("en-IN")}`}
                          </div>
                        </div>
                      </div>
                      
                      <div className="d-flex align-items-center gap-2">
                        <button
                          onClick={() => handelEdit(item, "edit")}
                          className="btn btn-secondary"
                          style={{ width: "32px", height: "32px", padding: "0", minWidth: "32px", borderRadius: "8px" }}
                        >
                          <img style={{ width: "12px", height: "12px", filter: "invert(1)" }} src={require("../../Common/Icon/edit.png")} alt="edit" />
                        </button>
                        <button
                          onClick={() => handelEdit(item, "delete")}
                          className="btn btn-secondary"
                          style={{ width: "32px", height: "32px", padding: "0", minWidth: "32px", borderRadius: "8px", background: "rgba(239, 68, 68, 0.05)", borderColor: "rgba(239, 68, 68, 0.1)" }}
                        >
                          <img style={{ width: "12px", height: "12px", filter: "invert(1)" }} src={require("../../Common/Icon/delete_icon.png")} alt="delete" />
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Accounts;
